@if (isAdmin) {
<div class="btn-container">
  <button pButton pRipple type="button" label="New Order Set" icon="pi pi-plus" (click)="openOrderSetDialog('create')">
  </button>
</div>
}

<div class="table-container">
  <p-table #dt [value]="orderSets" styleClass="p-datatable" [rowHover]="true" [rows]="5" [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          <div class="flex justify-content-between align-items-center">
            Name
            <p-sortIcon field="name"></p-sortIcon>
          </div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">
            Applied to schedule
          </div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">
            <div class="actions-title-container">Actions</div>
          </div>
        </th>
    </ng-template>

    <ng-template pTemplate="body" let-orderSet>
      <tr class="p-selectable-row">
        <td>
          {{ orderSet.name }}
        </td>
        <td>
          {{ hasBeenApplied(orderSet) ? "Yes": "No" }}
        </td>
        <td class="actions-container">
          <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View order set"
            (click)="viewOrderSet(orderSet)"></button>
          @if (isAdmin) {
          <button pButton type="button" class="p-button-warning" icon="pi pi-pencil" pTooltip="Edit order set"
            (click)="openOrderSetDialog('edit', orderSet)"></button>
          <button pButton type="button" class="p-button-danger" icon="pi pi-trash" pTooltip="Delete order set"
            (click)="deleteOrderSet(orderSet)"></button>
          <button pButton type="button" class="p-button-primary" icon="pi pi-check" pTooltip="Apply to schedule"
            (click)="applyOrderSet(orderSet)" [disabled]="hasBeenApplied(orderSet)"></button>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No order sets found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>